module.exports = __webpack_public_path__ + "static/media/theme-color-sample1.9b5a6e83.png";